export var Theme;

(function (Theme) {
  Theme["Light"] = "light";
  Theme["Dark"] = "dark";
})(Theme || (Theme = {}));